import type { LeaseActionProps } from '../../../models/Types';

export default function RedirectToSummary(props: LeaseActionProps) {
  const { lease, history, terminateActiveAction } = props;

  history.push(lease.getSummaryPath());
  terminateActiveAction();
  return null;
}
